"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventEmitter_1 = require("../Event/EventEmitter");
var AbrManagerDazn = /** @class */ (function () {
    function AbrManagerDazn(httpRequestMonitor, stateMachine, retry) {
        this.currentVariantIndex = -1;
        this.eventEmitter = new EventEmitter_1.default();
        this.config = undefined;
        this.httpRequestMonitor = httpRequestMonitor;
        this.stateMachine = stateMachine;
        this.retry = retry;
    }
    /*
     * Shaka AbrManager interface functions
     */
    /*
     * Chooses one variant to switch to. Called by the Player.
     */
    AbrManagerDazn.prototype.chooseVariant = function () {
        return this.getCurrentVariant();
    };
    /*
     * Sets the ABR configuration. It is the responsibility of the AbrManager implementation to implement
     * the restrictions behavior described in shaka.extern.AbrConfiguration.
     */
    AbrManagerDazn.prototype.configure = function (config) {
        this.config = config;
    };
    /*
     * Disables automatic Stream suggestions. After this, the AbrManager may not call switchCallback().
     */
    AbrManagerDazn.prototype.disable = function () {
        this.isEnabled = false;
    };
    /*
     * Enables automatic Variant choices from the last ones passed to setVariants. After this, the
     * AbrManager may call switchCallback() at any time
     */
    AbrManagerDazn.prototype.enable = function () {
        this.isEnabled = true;
    };
    /*
     * Gets an estimate of the current bandwidth in bit/sec. This is used by the Player to generate stats.
     */
    AbrManagerDazn.prototype.getBandwidthEstimate = function () {
        if (this.metrics) {
            return this.metrics.bandwidthEstimate;
        }
        else {
            return 0;
        }
    };
    /*
     * Initializes the AbrManager.
     */
    AbrManagerDazn.prototype.init = function (switchCallback) {
        this.switchCallback = switchCallback;
    };
    /*
     * Notifies the AbrManager that a segment has been downloaded (includes MP4 SIDX data, WebM Cues data,
     * initialization segments, and media segments).
     *
     * NOTE: this is called for AUDIO + VIDEO segments
     */
    AbrManagerDazn.prototype.segmentDownloaded = function (_1 /*deltaTimeMs*/, _2 /*numBytes*/) {
        this.updateVariant();
        this.retry.onNetworkSuccess();
    };
    /*
     * Updates manager's variants collection.
     */
    AbrManagerDazn.prototype.setVariants = function (variants) {
        var sortedVariants = this.sortVariants(variants);
        var filteredVariants = this.filterVariants(sortedVariants);
        if (filteredVariants.length === 0) {
            if (sortedVariants.length > 0) {
                filteredVariants.push(sortedVariants[sortedVariants.length - 1]);
            }
        }
        this.variants = filteredVariants;
        this.currentVariantIndex = 0;
        if (this.initialStateLabel) {
            this.setState(this.initialStateLabel);
        }
    };
    /*
     * Stops any background timers and frees any objects held by this instance. This will only be called
     * after a call to init.
     */
    AbrManagerDazn.prototype.stop = function () {
        this.retry.stop();
    };
    AbrManagerDazn.prototype.configureDazn = function (_ /*config*/) {
        // @todo DAZN specific configuration
    };
    AbrManagerDazn.prototype.onMetrics = function (metrics) {
        this.metrics = metrics;
        this.updateVariant();
        this.emit('metrics', metrics);
    };
    AbrManagerDazn.prototype.onTimeout = function () {
        this.updateVariant();
    };
    AbrManagerDazn.prototype.setCurrentVariantIndex = function (currentVariantIndex) {
        if (currentVariantIndex >= this.variants.length) {
            var msg = 'failed to set current variant index to [' + currentVariantIndex + ']';
            throw new Error(msg);
        }
        if (currentVariantIndex === this.currentVariantIndex) {
            return;
        }
        this.currentVariantIndex = currentVariantIndex;
        this.eventEmitter.emit('variant', this.getCurrentVariant());
    };
    AbrManagerDazn.prototype.getCurrentVariantIndex = function () {
        return this.currentVariantIndex;
    };
    AbrManagerDazn.prototype.setInitialState = function (label) {
        this.initialStateLabel = label;
    };
    AbrManagerDazn.prototype.setState = function (label, timeoutMilliseconds) {
        var _this = this;
        if (timeoutMilliseconds === void 0) { timeoutMilliseconds = 0; }
        var _a = this, metrics = _a.metrics, currentVariantIndex = _a.currentVariantIndex, variants = _a.variants;
        var params = {
            metrics: metrics,
            abrState: {
                currentVariantIndex: currentVariantIndex,
                variants: variants
            },
            callbacks: {
                setTimeoutLoad: function (ms) {
                    _this.httpRequestMonitor.setTimeoutLoad(ms);
                },
                setTimeoutFirstByte: function (ms) {
                    _this.httpRequestMonitor.setTimeoutFirstByte(ms);
                },
                timeoutAllActiveHttpRequests: function () {
                    _this.httpRequestMonitor.timeoutAllActiveHttpRequests();
                },
                setCurrentVariantIndex: function (variantIndex) {
                    _this.setCurrentVariantIndex(variantIndex);
                }
            }
        };
        this.stateMachine.setCurrentState(label, params, timeoutMilliseconds);
    };
    AbrManagerDazn.prototype.updateState = function () {
        var _this = this;
        var _a = this, metrics = _a.metrics, currentVariantIndex = _a.currentVariantIndex, variants = _a.variants;
        var params = {
            metrics: metrics,
            abrState: {
                currentVariantIndex: currentVariantIndex,
                variants: variants
            },
            callbacks: {
                setTimeoutLoad: function (ms) {
                    _this.httpRequestMonitor.setTimeoutLoad(ms);
                },
                setTimeoutFirstByte: function (ms) {
                    _this.httpRequestMonitor.setTimeoutFirstByte(ms);
                },
                timeoutAllActiveHttpRequests: function () {
                    _this.httpRequestMonitor.timeoutAllActiveHttpRequests();
                },
                setCurrentVariantIndex: function (variantIndex) {
                    _this.setCurrentVariantIndex(variantIndex);
                },
                setState: function (label) {
                    _this.setState(label);
                }
            }
        };
        this.stateMachine.update(params);
    };
    AbrManagerDazn.prototype.on = function (event, handler) {
        return this.eventEmitter.on(event, handler);
    };
    AbrManagerDazn.prototype.onFailureCallback = function (retryStreamingCallback) {
        this.retry.onNetworkFailure(retryStreamingCallback);
    };
    AbrManagerDazn.prototype.hasVariants = function () {
        return undefined !== this.variants;
    };
    AbrManagerDazn.prototype.getVariants = function () {
        return this.variants;
    };
    AbrManagerDazn.prototype.getCurrentVariant = function () {
        return this.variants[this.currentVariantIndex];
    };
    AbrManagerDazn.prototype.updateVariant = function () {
        this.updateState();
        if (this.isEnabled && this.switchCallback) {
            try {
                this.switchCallback(this.getCurrentVariant());
            }
            catch (error) {
                /// @todo is there any value in tracking this error?
            }
        }
    };
    AbrManagerDazn.prototype.emit = function (event, data) {
        this.eventEmitter.emit(event, data);
    };
    AbrManagerDazn.prototype.sortVariants = function (variants) {
        var variantsSortedDescending = variants.slice().sort(function (a, b) {
            return b.bandwidth - a.bandwidth;
        });
        return variantsSortedDescending;
    };
    AbrManagerDazn.prototype.filterVariants = function (variants) {
        if (undefined === this.config) {
            return variants;
        }
        var _a = this.config.restrictions, maxBandwidth = _a.maxBandwidth, maxHeight = _a.maxHeight, maxPixels = _a.maxPixels, maxWidth = _a.maxWidth, minBandwidth = _a.minBandwidth, minHeight = _a.minHeight, minPixels = _a.minPixels, minWidth = _a.minWidth;
        var filteredVariants = variants.filter(function (variant) {
            var _a = variant.video, width = _a.width, height = _a.height;
            var numPixels = height * width;
            return (variant.bandwidth <= maxBandwidth)
                && (height <= maxHeight)
                && (numPixels <= maxPixels)
                && (width <= maxWidth)
                && (variant.bandwidth >= minBandwidth)
                && (height >= minHeight)
                && (numPixels >= minPixels)
                && (width >= minWidth);
        });
        return filteredVariants;
    };
    return AbrManagerDazn;
}());
exports.default = AbrManagerDazn;
//# sourceMappingURL=AbrManagerDazn.js.map